var _defs, _polyline, _polyline2, _polyline3, _path, _polyline4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _polyline5, _polyline6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvAuthenticityGuarantee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c,.d{fill:none;}.a{stroke:#81949c;}.a,.b,.c{stroke-linecap:round;stroke-linejoin:round;}.b{stroke:#80939a;}.c{stroke:#ff5a00;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "82.99 15.865 67.553 15.865 67.553 0.542 67.553 0.542"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "82.99 81.298 82.99 15.865 67.526 0.542 17.01 0.542 17.01 94.528 61.132 94.528"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "73.263 94.528 82.99 94.528 82.99 77.522"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M55.851,9.865A7.943,7.943,0,0,0,44.7,9.309a7.771,7.771,0,0,0-.561,11.046,7.944,7.944,0,0,0,11.147.556,7.844,7.844,0,0,0,1.041-1.137"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "47.054 12.17 50.315 15.09 52.34 12.995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,44.523H74.369"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,49.529H74.369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,54.516H74.369"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,35.524H45.391"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,64.559H49.986"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.537,59.557H74.369"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M71.481,80.714h0a1.3,1.3,0,0,1,1.449,1.132,1.272,1.272,0,0,1-.005.354h0a3.329,3.329,0,0,0,1.247,3.131h0a1.3,1.3,0,0,1-.029,2.073h0a3.334,3.334,0,0,0-1.333,3.09h0a1.3,1.3,0,0,1-1.13,1.45,1.286,1.286,0,0,1-.356-.005h0A3.332,3.332,0,0,0,68.2,93.182h0a1.3,1.3,0,0,1-1.825.226,1.281,1.281,0,0,1-.248-.256h0a3.336,3.336,0,0,0-3.09-1.332h0a1.3,1.3,0,0,1-1.445-1.487h0a3.33,3.33,0,0,0-1.243-3.126h0a1.3,1.3,0,0,1-.226-1.824,1.342,1.342,0,0,1,.256-.249h0a3.33,3.33,0,0,0,1.332-3.09h0a1.3,1.3,0,0,1,1.13-1.45,1.333,1.333,0,0,1,.357.005h0a3.33,3.33,0,0,0,3.127-1.243h0a1.3,1.3,0,0,1,1.825-.224,1.321,1.321,0,0,1,.247.254h0A3.332,3.332,0,0,0,71.481,80.714Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 67.255,
    cy: 86.341,
    r: 3.83
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "62.787 91.846 59.389 97.352 63.41 99.458 67.048 93.666"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "c",
    points: "71.68 91.944 74.995 97.352 70.974 99.458 67.335 93.666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: -727.864,
    y: -414.744,
    width: 1260,
    height: 1962
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvAuthenticityGuarantee);
export default __webpack_public_path__ + "static/media/sv-authenticity-guarantee.0a7e2baef47e03e86d5a26afb66a18a7.svg";
export { ForwardRef as ReactComponent };